import { ModelCity } from 'models/ModelCity'

type ItineraryUrlSource = {
  id: string
  cities?: Array<Pick<ModelCity, 'name'>>
}

const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

export const isUuidItineraryId = (id = '') =>
  UUID_PATTERN.test(String(id).trim())

export const shortItineraryId = (id = '') => {
  if (!isUuidItineraryId(id)) return ''

  const normalized = String(id).replace(/-/g, '').toLowerCase()
  return `${normalized.slice(0, 8)}${normalized.slice(-8)}`
}

export const slugifyUrlPart = (value = '') =>
  String(value)
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')

export const itineraryDestinationSegment = (
  cities: Array<Pick<ModelCity, 'name'>> = []
) => {
  const uniqueNames = Array.from(
    new Set(
      cities
        .map((city) =>
          String(city?.name || '')
            .split(',')[0]
            .trim()
        )
        .filter(Boolean)
    )
  )

  if (uniqueNames.length === 0) return 'roteiro'

  const visibleDestinations = uniqueNames
    .slice(0, 2)
    .map(slugifyUrlPart)
    .filter(Boolean)

  if (visibleDestinations.length === 0) return 'roteiro'

  return uniqueNames.length > 2
    ? `${visibleDestinations.join('-')}-e-mais`
    : visibleDestinations.join('-')
}

export const getItineraryPublicPath = ({
  id,
  cities = []
}: ItineraryUrlSource) => {
  const shortId = shortItineraryId(id)
  const destinationSegment = itineraryDestinationSegment(cities)

  if (shortId) {
    return `/roteiros/${destinationSegment}/${shortId}`
  }

  const legacyId = String(id || '').trim()
  return legacyId ? `/roteiro/${encodeURIComponent(legacyId)}` : '/roteiros'
}
